import { RootState } from 'store/rootReducer';

export const getActiveSystemPopupSelector = (state: RootState) =>
  state.systemPopup.type;

export const getActiveSystemPopupParamsSelector = (state: RootState) =>
  state.systemPopup.params;

export const isAnySystemPopupOpenSelector = (state: RootState) =>
  !!state.systemPopup.type;
